// extracted by mini-css-extract-plugin
module.exports = {"headText":"ingredient_headText__cQ6hD"};